import script from "./Options.vue?vue&type=script&lang=ts&setup=true"
export * from "./Options.vue?vue&type=script&lang=ts&setup=true"

import "./Options.vue?vue&type=style&index=0&id=06ee2b0c&lang=css"

const __exports__ = script;

export default __exports__